var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthDataPlatform6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.49,
    height: 48.185,
    viewBox: "0 0 41.49 48.185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15123",
    "data-name": "Group 15123",
    transform: "translate(-263.796 -345)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41159",
    "data-name": "Path 41159",
    d: "M300.879,370.452a18.543,18.543,0,1,1-18.6-18.718A18.559,18.559,0,0,1,300.879,370.452Zm-35.5-1.378c-.039.837.292,1.295.875,1.365a1.029,1.029,0,0,0,1.164-.951c.022-.109.024-.222.037-.334a15.429,15.429,0,0,1,3.389-8.26,16.311,16.311,0,0,1,4.395-3.707,11.742,11.742,0,0,1,3.081-1.283,1.021,1.021,0,0,0,.76-1.3,1.045,1.045,0,0,0-1.262-.7,4,4,0,0,0-.4.125,17.981,17.981,0,0,0-6.9,4.165,17.6,17.6,0,0,0-2.318,2.864A17.028,17.028,0,0,0,265.378,369.074Zm7.767,2.971a6.448,6.448,0,0,0,.737,3.428,4.938,4.938,0,0,0,4.562,2.645,4.814,4.814,0,0,0,4.594-2.575,6.606,6.606,0,0,0-.077-6.6,5.308,5.308,0,0,0-9.253.511A6.155,6.155,0,0,0,273.146,372.046Zm12.261.779a.663.663,0,0,0,.169.1c.591.116,1.187.333,1.4-.583.087-.366.6-.487,1.01-.392a.875.875,0,0,1,.7.834,1.478,1.478,0,0,1-.413,1.153c-.3.334-.62.647-.941.959a12.448,12.448,0,0,0-1.441,1.526,2.84,2.84,0,0,0-.642,1.706c1.5,0,2.928,0,4.353,0,.3,0,.458-.066.483-.408.059-.816.01-.887-.848-.893l-1.929-.01a12.078,12.078,0,0,1,1.519-1.566,4.11,4.11,0,0,0,1.1-1.568,2.037,2.037,0,0,0-.342-2.2,2.5,2.5,0,0,0-2.722-.569A1.969,1.969,0,0,0,285.407,372.825Z",
    transform: "translate(0 4.082)",
    fill: "#ef6286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41160",
    "data-name": "Path 41160",
    d: "M288.322,358.5a5.507,5.507,0,1,1,5.437-5.479A5.491,5.491,0,0,1,288.322,358.5ZM284,352.677a5.289,5.289,0,0,0,.846,3.208.811.811,0,0,0,1.291.167c.32-.3.334-.651.05-1.182a3.387,3.387,0,0,1,.607-4.255c.048-.048.1-.092.146-.145a.809.809,0,0,0-.022-1.118.822.822,0,0,0-1.063-.109,2.366,2.366,0,0,0-.369.3A4.6,4.6,0,0,0,284,352.677Z",
    transform: "translate(11.528 1.509)",
    fill: "#ef6286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41161",
    "data-name": "Path 41161",
    d: "M284.423,347.8a2.783,2.783,0,1,1-5.565.032A2.793,2.793,0,0,1,281.632,345,2.763,2.763,0,0,1,284.423,347.8Zm-4.851.117a2.233,2.233,0,0,0,1.161,1.908.5.5,0,0,0,.573.061.54.54,0,0,0,.215-.541.953.953,0,0,0-.488-.705.941.941,0,0,1-.149-1.528c.111-.124.243-.233.341-.366a.744.744,0,0,0,.095-.879c-.172-.18-.549-.13-.859.132A2.4,2.4,0,0,0,279.573,347.92Z",
    transform: "translate(9.13)",
    fill: "#ef6286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41162",
    "data-name": "Path 41162",
    d: "M270.549,366.241a7.831,7.831,0,0,1,.26-1.913,3.63,3.63,0,0,1,3.257-2.623,3.565,3.565,0,0,1,3.556,1.913,5.875,5.875,0,0,1,.133,5.047,3.575,3.575,0,0,1-4.073,2.1,3.735,3.735,0,0,1-3.049-3.269C270.575,367.082,270.576,366.66,270.549,366.241Z",
    transform: "translate(4.093 10.115)",
    fill: "#ef6286"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthDataPlatform6);
export default __webpack_public_path__ + "static/media/health_data_platform6.cee23c147dcedecbadc11c42e7111415.svg";
export { ForwardRef as ReactComponent };